export const global = {
    apiUrl: location.hostname === 'localhost' || location.hostname === '127.0.0.1' ? 'http://localhost:62328/api/' : '/api/api/',
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy HH:mm',
    title: 'Crawford Eye Claims',
    logo: './assets/images/EyeClaims-logo-white.png',
    version: '0.3.21'
  };





// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/app.settings.ts